import React, {useEffect} from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {Link, useHistory} from "react-router-dom";
import useToken from '../useToken';
import {loginResources, sistemaResources} from "../endpoints";
import SvgIcon from '@material-ui/core/SvgIcon';
import SearchIcon from '@material-ui/icons/Search';
import ExposureIcon from '@material-ui/icons/Exposure';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import StorageIcon from '@mui/icons-material/Storage';
import PageviewIcon from '@material-ui/icons/Pageview';
import Grid from "@material-ui/core/Grid";
import HistoryIcon from '@material-ui/icons/History';
import { Dialog, DialogContent, DialogTitle, Tooltip, Fade } from "@material-ui/core";
import TablaProcesos from "./TablaProcesos";
import DialogPassSupervision from "./DialogPassSupervision";
import LineAxisIcon from '@mui/icons-material/LineAxis';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import GradingIcon from '@mui/icons-material/Grading';
import ChecklistIcon from '@mui/icons-material/Checklist';
import StarsIcon from '@mui/icons-material/Stars';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import IndicadorConexion from './IndicadorConexion/IndicadorConexion';
import BackupIcon from '@mui/icons-material/Backup';
import FolderIcon from '@material-ui/icons/Folder';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(1),
    },
    title: {
        flexGrow: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    link: {
        color: '#000000',
        textDecoration: 'none'
    },
    paper: {
        border: '2px solid #d3d4d5',
    },

    paper2: {
        position: 'absolute',
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 2, 2),
    },
}));


export default function SwipeableTemporaryDrawer() {
    const [user, setUser] = React.useState(useToken.getUser());
    const [datos, setDatos] = React.useState(useToken.getDatos());

    const classes = useStyles();
    const history = useHistory();
    const [state, setState] = React.useState({
        left: false,
    });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [openProcesos, setOpenProcesos] = React.useState(false);
    const [version, setVersion] = React.useState(null);
    const [openPass, setOpenPass] = React.useState(false);
    const [existeFolio,setExisteFolio] = React.useState(null);
    const [menu, setMenu] = React.useState('general');
    const [encargadoTienda, setEncargadoTienda] = React.useState(false);
    const [openSubmenu, setOpenSubmenu] = React.useState(false);

    const [openAdminSub, setOpenAdminSub] = React.useState({
        paneles: false,
        sodimac: false,
        consultas: false,
    });

    const name_host = window.location.hostname

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePass = ()=>{
        handleClose();
        setOpenPass(true);
    }

    const handleClosePass =()=>{
        handleClose();
        setOpenPass(false);
    }

    const handleLogout = () => {
        loginResources.logout();
        history.push("/");

    };

  /*  const handleClick = () => {
        setOpenItem(!openItem);
    };*/

    const handleCloseProcesos = () =>{
        handleClose();
        setOpenProcesos(false);
    }

    const handleChangeProcesos =()=>{
        handleClose();
        setOpenProcesos(true);
    }

    const getVersion = () =>{
        sistemaResources.getVersion().then(async response => {
            if (response.status === 200) {
                return await response.json();
            }
            else{
                throw new Error('Something went wrong ...');
            }
            }).then(data => {
                if (data !== null){
                    const version = "v." + data
                    setVersion(version)
                }
        }).catch(error=> {
            console.error(error);
        });
    }

    const verificaEncargadoTienda = React.useCallback(() => {
        const datos = useToken.getDatos();

        if (datos && datos.folio && user?.id_usuario) {
            loginResources
                .verificaEncargadoTienda(user.id_usuario)
                .then(async response => {
                    if (response.status === 200) {
                        return await response.json();
                    } else {
                        throw new Error('Something went wrong ...');
                    }
                })
                .then(data => {
                    setEncargadoTienda(data ? data.exists : false);
                })
                .catch(error => {
                    console.error(error);
                    setEncargadoTienda(false);
                });
        }
    }, [user]);   // 👈 depende de user

    const verificaFolio = () =>{
        const verifyFolio = useToken.verifyToken()
        setExisteFolio(verifyFolio)
    }

    const handleClickSubmenu = () => {
        setOpenSubmenu(!openSubmenu);
    };

    useEffect(() => {
        getVersion();
        verificaEncargadoTienda();
        verificaFolio();
    }, [verificaEncargadoTienda]);


    useEffect(() => {
        const refresh = () => {
            const newUser = useToken.getUser();
            const newDatos = useToken.getDatos();

            setUser(newUser);
            setDatos(newDatos);

            verificaEncargadoTienda();
            verificaFolio();
        };

        window.addEventListener("token-updated", refresh);
        return () => window.removeEventListener("token-updated", refresh);
    }, [verificaEncargadoTienda]);

    
    useEffect(() => {
        if (!user?.perfil) return;

        if (user.perfil === 'analista oficina sodimac'){
            setMenu('panelSodimac')
        }
        else if (user.perfil === 'validador walmart' || user.perfil === 'validador walmart parciales'){
            setMenu('validadorWalmart')
        }
        else if (user.perfil === 'analista smu perecible'){
            setMenu('panelAuditorias')
        }
        else if (user.perfil === 'analista walmart'){
            setMenu('analistaWalmart')
        }
        else if (user.perfil === 'oficina SCA'){
            setMenu('oficina')
        }
        else if ( user.perfil === 'admin'){
            setMenu('admin')
        }
        else{
            setMenu('general')
        }
    }, [user]);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const toggleSub = (key) => {
        setOpenAdminSub(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const renderSubmenuConsultas = (anchor) => (
        <>
            <ListItem button onClick={() => toggleSub('consultas')}>
                <ListItemIcon>
                    <SearchIcon />
                </ListItemIcon>
                <ListItemText primary="Consultas" />
                {openAdminSub.consultas ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openAdminSub.consultas} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <Link to="/consultar_tag" className={classes.link}>
                        <ListItem
                            button
                            className={classes.nested}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                        >
                            <ListItemText primary="Consultar Tag" />
                        </ListItem>
                    </Link>
                    <Link to="/consultar_codigo" className={classes.link}>
                        <ListItem
                            button
                            className={classes.nested}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                        >
                            <ListItemText primary="Consultar Código" />
                        </ListItem>
                    </Link>
                    <Link to="/consultar_operador" className={classes.link}>
                        <ListItem
                            button
                            className={classes.nested}
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                        >
                            <ListItemText primary="Consultar Operador" />
                        </ListItem>
                    </Link>
                </List>
            </Collapse>
        </>
    );

    const menuPanelSodimac = (anchor) => (
        <div  className={clsx(classes.list)} role="presentation">
            <List>
                <Link to="/panel_sodimac_diario" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel diario'} />
                    </ListItem>
                </Link>
                <Link to="/panel_sodimac_semanal" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel semanal'} />
                    </ListItem>
                </Link>
                <Link to="/panel_sodimac_historico" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel histórico'} />
                    </ListItem>
                </Link>
                 <Link to="/panel_auditorias_altillo" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel Aud. Altillo'} />
                    </ListItem>
                </Link>
                 <Link to="/panel_auditorias_visual" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel Aud. Visual'} />
                    </ListItem>
                </Link>
                <Link to="/exportaciones_panel" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Exportaciones'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    const menuPanelAuditorias = (anchor) => (
        <div  className={clsx(classes.list)} role="presentation">
            <List>
                <Link to="/panel_auditorias" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LineAxisIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Panel diario'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    const menuValidadorWalmart = (anchor) => (
        <div  className={clsx(classes.list)}
              role="presentation">
            <List>
                <Link to={"/inventarios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inventarios"/>
                    </ListItem>
                </Link>
                <Link to={"/revision_reportes"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ChecklistIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Revisión Reportes"/>
                    </ListItem>
                </Link>
                {encargadoTienda &&
                    <Link to={"/caminado_tickets"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <LibraryAddCheckIcon/>
                            </ListItemIcon>
                        <ListItemText primary="Caminado Tickets"/>
                        </ListItem>
                    </Link>
                }
            </List>
        </div>

    );

    const menuAnalistaWalmart = (anchor) => (
        <div  className={clsx(classes.list)}
              role="presentation">
            <List>
                {name_host === 'scaneptuno.cl' && (
                <>
                    <ListItem button onClick={() => toggleSub('paneles')}>
                        <ListItemIcon><LineAxisIcon/></ListItemIcon>
                        <ListItemText primary="Panel y Archivos" />
                        {openAdminSub.paneles ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>

                    <Collapse in={openAdminSub.paneles} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link to="/panel_general" className={classes.link}>
                                <ListItem button className={classes.nested} onClick={toggleDrawer(anchor, false)}>
                                    <ListItemText primary="Panel Retail" />
                                </ListItem>
                            </Link>
                            <Link to={"/gestion_archivos"} className={classes.link}>
                                <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                    <ListItemIcon>
                                        <FolderIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Gestión de Archivos"/>
                                </ListItem>
                            </Link>
                        </List>
                    </Collapse>
                </>)}
                <Link to={"/inventarios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inventarios"/>
                    </ListItem>
                </Link>
                <Link to="/avance" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Avance'} />
                    </ListItem>
                </Link>
                <Link to={"/ubicaciones"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary="Ubicaciones"/>
                    </ListItem>
                </Link>

                {renderSubmenuConsultas(anchor)}

                <Link to="/diferencias" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Variance/Diferencias'} />
                    </ListItem>
                </Link>
                {/* Item con Submenu */}
                <ListItem button onClick={handleClickSubmenu}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Validación"} />
                    {openSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openSubmenu} unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to="/tags_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Por cantidad" />
                            </ListItem>
                        </Link>
                        <Link to="/cambios_codigos_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cambios de Códigos" />
                            </ListItem>
                        </Link>
                        <Link to="/cantidad_por_codigo_validado" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cantidad x Código" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Link to="/importaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Importaciones'} />
                    </ListItem>
                </Link>
                <Link to="/exportar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Exportaciones'} />
                    </ListItem>
                </Link>
                <Link to="/reportes" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <InsertDriveFileIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Reportes'} />
                    </ListItem>
                </Link>
                { /*<Link to={"/revision_precios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <PriceCheckIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Revisión Precios"/>
                    </ListItem>
                </Link> */}
                <Link to={"/revision_reportes"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ChecklistIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Revisión Reportes"/>
                    </ListItem>
                </Link>
                <Link to="/detalle_diferencia/jerarquia/-1/-1/-1" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'No Contado'} />
                    </ListItem>
                </Link>
                <Link to="/mandatorios" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SearchIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Mandatorios'} />
                    </ListItem>
                </Link>
                <Link to="/validadores_cliente" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <AccountCircle/>
                        </ListItemIcon>
                        <ListItemText primary={'Validadores Cliente'} />
                    </ListItem>
                </Link>
                <Link to={"/caminado_tickets"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <LibraryAddCheckIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Caminado Tickets"/>
                    </ListItem>
                </Link>
                <Link to="/rnr" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'RNR'} />
                    </ListItem>
                </Link>
                <Link to="/recount_sheets" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Recount Sheets'} />
                    </ListItem>
                </Link>
                <Link to="/high_dollar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <AttachMoneyIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'High Dollar'} />
                    </ListItem>
                </Link>
                <Link to="/observaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <PageviewIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Observaciones'} />
                    </ListItem>
                </Link>
                <Link to="/rendimiento" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StarsIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Rendimiento'} />
                    </ListItem>
                </Link>
                <Link to="/historial" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <HistoryIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Historial'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    const menuGeneral = (anchor) => (
        <div  className={clsx(classes.list)}
              role="presentation">
            <List>
                <Link to={"/inventarios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inventarios"/>
                    </ListItem>
                </Link>
                {/*<Link to={"/dashboard"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <DashboardIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Dashboard"/>
                    </ListItem>
                </Link>*/}
                <Link to="/avance" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Avance'} />
                    </ListItem>
                </Link>
                <Link to={"/ubicaciones"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary="Ubicaciones"/>
                    </ListItem>
                </Link>

                {renderSubmenuConsultas(anchor)}

                <Link to="/diferencias" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Variance/Diferencias'} />
                    </ListItem>
                </Link>
                {/* Item con Submenu */}
                <ListItem button onClick={handleClickSubmenu}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Validación"} />
                    {openSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openSubmenu} unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to="/tags_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Por cantidad" />
                            </ListItem>
                        </Link>
                        <Link to="/cambios_codigos_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cambios de Códigos" />
                            </ListItem>
                        </Link>
                        <Link to="/cantidad_por_codigo_validado" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cantidad x Código" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Link to="/importaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Importaciones'} />
                    </ListItem>
                </Link>
                <Link to="/exportar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Exportaciones'} />
                    </ListItem>
                </Link>
                <Link to="/reportes" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <InsertDriveFileIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Reportes'} />
                    </ListItem>
                </Link>
                {(user.app === 'walmart' || user.app === 'walmart_parciales') &&
                    <List onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        { /*<Link to={"/revision_precios"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <PriceCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Precios"/>
                            </ListItem>
                        </Link> */}
                        <Link to={"/revision_reportes"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ChecklistIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Reportes"/>
                            </ListItem>
                        </Link>
                        <Link to="/detalle_diferencia/jerarquia/-1/-1/-1" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ExposureIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'No Contado'} />
                            </ListItem>
                        </Link>
                        <Link to="/mandatorios" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SearchIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Mandatorios'} />
                            </ListItem>
                        </Link>
                        <Link to="/validadores_cliente" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <AccountCircle/>
                                </ListItemIcon>
                                <ListItemText primary={'Validadores Cliente'} />
                            </ListItem>
                        </Link>
                        <Link to={"/caminado_tickets"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <LibraryAddCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Caminado Tickets"/>
                            </ListItem>
                        </Link>
                        <Link to="/rnr" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'RNR'} />
                            </ListItem>
                        </Link>
                        <Link to="/recount_sheets" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'Recount Sheets'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                {(user.app === 'sodimac' || user.app === 'sodimac_auditoria') &&
                    <List style={{marginTop:-15}}  onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        <Link to="/auditoria_visual" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <GradingIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Auditoría Visual'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                {
                    (user.app === 'dbs') &&
                     <Link to="/validadores_cliente" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <AccountCircle/>
                                </ListItemIcon>
                                <ListItemText primary={'Validadores Cliente'} />
                            </ListItem>
                    </Link>
                }
                { /*
                <Link to="/diferencias_por_ubicacion" className={classes.link}>
                    <ListItem button>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Diferencias Por Ubicación'} />
                    </ListItem>
                </Link>*/}
                <Link to="/high_dollar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <AttachMoneyIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'High Dollar'} />
                    </ListItem>
                </Link>
                <Link to="/observaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <PageviewIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Observaciones'} />
                    </ListItem>
                </Link>
                <Link to="/rendimiento" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StarsIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Rendimiento'} />
                    </ListItem>
                </Link>
                <Link to="/historial" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <HistoryIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Historial'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );
    
    const menuAdmin = (anchor) => (
        <div  className={clsx(classes.list)}
              role="presentation">
            <List>
                {name_host === 'scaneptuno.cl' && (
                <>
                    <ListItem button onClick={() => toggleSub('paneles')}>
                        <ListItemIcon><LineAxisIcon/></ListItemIcon>
                        <ListItemText primary="Monitoreo y Paneles" />
                        {openAdminSub.paneles ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>

                    <Collapse in={openAdminSub.paneles} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <Link to="/panel_general" className={classes.link}>
                                <ListItem button className={classes.nested} onClick={toggleDrawer(anchor, false)}>
                                    <ListItemText primary="Panel Retail" />
                                </ListItem>
                            </Link>
                            <Link to="/panel_auditorias" className={classes.link}>
                                <ListItem button className={classes.nested} onClick={toggleDrawer(anchor, false)}>
                                    <ListItemText primary="Panel Auditorías" />
                                </ListItem>
                            </Link>
                            <Link to="/datos_productividad" className={classes.link}>
                                <ListItem button className={classes.nested} onClick={toggleDrawer(anchor, false)}>
                                    <ListItemText primary="Productividad Operadores" />
                                </ListItem>
                            </Link>
                            <Link to="/control_respaldos" className={classes.link}>
                                <ListItem button className={classes.nested} onClick={toggleDrawer(anchor, false)}>
                                    <ListItemText primary="Control de Respaldos" />
                                </ListItem>
                            </Link>

                            <ListItem button className={classes.nested} onClick={() => toggleSub('sodimac')}>
                                <ListItemText primary="Paneles Sodimac" />
                                {openAdminSub.sodimac ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>

                            <Collapse in={openAdminSub.sodimac} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <Link to="/panel_sodimac_diario" className={classes.link}>
                                    <ListItem button style={{ paddingLeft: 48 }} onClick={toggleDrawer(anchor, false)}>
                                        <ListItemText primary="Panel Diario" />
                                    </ListItem>
                                    </Link>
                                    <Link to="/panel_sodimac_semanal" className={classes.link}>
                                    <ListItem button style={{ paddingLeft: 48 }} onClick={toggleDrawer(anchor, false)}>
                                        <ListItemText primary="Panel Semanal" />
                                    </ListItem>
                                    </Link>
                                    <Link to="/panel_sodimac_historico" className={classes.link}>
                                    <ListItem button style={{ paddingLeft: 48 }} onClick={toggleDrawer(anchor, false)}>
                                        <ListItemText primary="Panel Histórico" />
                                    </ListItem>
                                    </Link>
                                    <Link to="/panel_auditorias_altillo" className={classes.link}>
                                    <ListItem button style={{ paddingLeft: 48 }} onClick={toggleDrawer(anchor, false)}>
                                        <ListItemText primary="Panel Aud. Altillo" />
                                    </ListItem>
                                    </Link>
                                    <Link to="/panel_auditorias_visual" className={classes.link}>
                                    <ListItem button style={{ paddingLeft: 48 }} onClick={toggleDrawer(anchor, false)}>
                                        <ListItemText primary=" Panel Aud. Visual" />
                                    </ListItem>
                                    </Link>
                                </List>
                            </Collapse>
                        </List>
                    </Collapse>
                    <Link to={"/gestion_archivos"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <FolderIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Gestión de Archivos"/>
                        </ListItem>
                    </Link>
                </>)}
                <Link to={"/inventarios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inventarios"/>
                    </ListItem>
                </Link>
                <Link to="/avance" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Avance'} />
                    </ListItem>
                </Link>
                <Link to={"/ubicaciones"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary="Ubicaciones"/>
                    </ListItem>
                </Link>

                {renderSubmenuConsultas(anchor)}

                <Link to="/diferencias" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Variance/Diferencias'} />
                    </ListItem>
                </Link>
                {/* Item con Submenu */}
                <ListItem button onClick={handleClickSubmenu}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Validación"} />
                    {openSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openSubmenu} unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to="/tags_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Por cantidad" />
                            </ListItem>
                        </Link>
                        <Link to="/cambios_codigos_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cambios de Códigos" />
                            </ListItem>
                        </Link>
                        <Link to="/cantidad_por_codigo_validado" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cantidad x Código" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Link to="/importaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Importaciones'} />
                    </ListItem>
                </Link>
                <Link to="/exportar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Exportaciones'} />
                    </ListItem>
                </Link>
                <Link to="/reportes" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <InsertDriveFileIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Reportes'} />
                    </ListItem>
                </Link>
                {(user.app === 'walmart' || user.app === 'walmart_parciales') &&
                    <List onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        {/* <Link to={"/revision_precios"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <PriceCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Precios"/>
                            </ListItem>
                        </Link> */}
                        <Link to={"/revision_reportes"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ChecklistIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Reportes"/>
                            </ListItem>
                        </Link>
                        <Link to="/detalle_diferencia/jerarquia/-1/-1/-1" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ExposureIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'No Contado'} />
                            </ListItem>
                        </Link>
                        <Link to="/mandatorios" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SearchIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Mandatorios'} />
                            </ListItem>
                        </Link>
                        <Link to="/validadores_cliente" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <AccountCircle/>
                                </ListItemIcon>
                                <ListItemText primary={'Validadores Cliente'} />
                            </ListItem>
                        </Link>
                        <Link to={"/caminado_tickets"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <LibraryAddCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Caminado Tickets"/>
                            </ListItem>
                        </Link>
                        <Link to="/rnr" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'RNR'} />
                            </ListItem>
                        </Link>
                        <Link to="/recount_sheets" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'Recount Sheets'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                {(user.app === 'sodimac' || user.app === 'sodimac_auditoria') &&
                    <List style={{marginTop:-15}}  onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        <Link to="/auditoria_visual" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <GradingIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Auditoría Visual'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                { /*
                <Link to="/diferencias_por_ubicacion" className={classes.link}>
                    <ListItem button>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Diferencias Por Ubicación'} />
                    </ListItem>
                </Link>*/}
                <Link to="/high_dollar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <AttachMoneyIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'High Dollar'} />
                    </ListItem>
                </Link>
                <Link to="/observaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <PageviewIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Observaciones'} />
                    </ListItem>
                </Link>
                <Link to="/rendimiento" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StarsIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Rendimiento'} />
                    </ListItem>
                </Link>
                <Link to="/historial" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <HistoryIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Historial'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    const menuOficina = (anchor) => (
        <div  className={clsx(classes.list)}
              role="presentation">
            <List>
                {name_host === 'scaneptuno.cl' &&
                    <Link to={"/panel_general"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <LineAxisIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Panel General"/>
                        </ListItem>
                    </Link>
                }
                {name_host === 'scaneptuno.cl' &&
                    <Link to={"/panel_auditorias"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <LineAxisIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Panel Auditorias"/>
                        </ListItem>
                    </Link>
                }
                {name_host === 'scaneptuno.cl' &&
                    <Link to={"/datos_productividad"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <LineAxisIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Productividad Operadores"/>
                        </ListItem>
                    </Link>
                }
                {name_host === 'scaneptuno.cl' &&
                    <Link to={"/control_respaldos"} className={classes.link}>
                        <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                            <ListItemIcon>
                                <BackupIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Control de Respaldos"/>
                        </ListItem>
                    </Link>
                }
                {/*
                {name_host === 'scaneptuno.cl' &&
                <Link to={"/gestion_archivos"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <FolderIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Gestión de Archivos"/>
                    </ListItem>
                </Link>}
                */}
                <Link to={"/inventarios"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Inventarios"/>
                    </ListItem>
                </Link>
                <Link to="/avance" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Avance'} />
                    </ListItem>
                </Link>
                <Link to={"/ubicaciones"} className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary="Ubicaciones"/>
                    </ListItem>
                </Link>
                
                {renderSubmenuConsultas(anchor)}

                <Link to="/diferencias" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Variance/Diferencias'} />
                    </ListItem>
                </Link>
                {/* Item con Submenu */}
                <ListItem button onClick={handleClickSubmenu}>
                    <ListItemIcon>
                        <AssignmentTurnedInIcon/>
                    </ListItemIcon>
                    <ListItemText primary={"Validación"} />
                    {openSubmenu ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openSubmenu} unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to="/tags_validados" className={classes.link}>
                            <ListItem
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Por cantidad" />
                            </ListItem>
                        </Link>
                        <Link to="/cambios_codigos_validados" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cambios de Códigos" />
                            </ListItem>
                        </Link>
                        <Link to="/cantidad_por_codigo_validado" className={classes.link}>
                            <ListItem 
                                button 
                                className={classes.nested}
                                onClick={toggleDrawer(anchor, false)}
                                onKeyDown={toggleDrawer(anchor, false)}
                            >
                                <ListItemText primary="Cantidad x Código" />
                            </ListItem>
                        </Link>
                    </List>
                </Collapse>
                <Link to="/importaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Importaciones'} />
                    </ListItem>
                </Link>
                <Link to="/exportar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText primary={'Exportaciones'} />
                    </ListItem>
                </Link>
                <Link to="/reportes" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <InsertDriveFileIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Reportes'} />
                    </ListItem>
                </Link>
                {(user.app === 'walmart' || user.app === 'walmart_parciales') &&
                    <List onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        {/* <Link to={"/revision_precios"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <PriceCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Precios"/>
                            </ListItem>
                        </Link> */}
                        <Link to={"/revision_reportes"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ChecklistIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Revisión Reportes"/>
                            </ListItem>
                        </Link>
                        <Link to="/detalle_diferencia/jerarquia/-1/-1/-1" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <ExposureIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'No Contado'} />
                            </ListItem>
                        </Link>
                        <Link to="/mandatorios" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SearchIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Mandatorios'} />
                            </ListItem>
                        </Link>
                        <Link to="/validadores_cliente" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <AccountCircle/>
                                </ListItemIcon>
                                <ListItemText primary={'Validadores Cliente'} />
                            </ListItem>
                        </Link>
                        <Link to={"/caminado_tickets"} className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <LibraryAddCheckIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Caminado Tickets"/>
                            </ListItem>
                        </Link>
                        <Link to="/rnr" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'RNR'} />
                            </ListItem>
                        </Link>
                        <Link to="/recount_sheets" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <SvgIcon>
                                        <path fill="currentColor" d="M15,7H20.5L15,1.5V7M8,0H16L22,6V18A2,2 0 0,1 20,20H8C6.89,20 6,19.1 6,18V2A2,2 0 0,1 8,0M4,4V22H20V24H4A2,2 0 0,1 2,22V4H4Z" />
                                    </SvgIcon>
                                </ListItemIcon>
                                <ListItemText primary={'Recount Sheets'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                {(user.app === 'sodimac' || user.app === 'sodimac_auditoria') &&
                    <List style={{marginTop:-15}}  onClick={toggleDrawer(anchor, false)}
                          onKeyDown={toggleDrawer(anchor, false)}>
                        <Link to="/auditoria_visual" className={classes.link}>
                            <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                                <ListItemIcon>
                                    <GradingIcon/>
                                </ListItemIcon>
                                <ListItemText primary={'Auditoría Visual'} />
                            </ListItem>
                        </Link>
                    </List>
                }
                { /*
                <Link to="/diferencias_por_ubicacion" className={classes.link}>
                    <ListItem button>
                        <ListItemIcon>
                            <ExposureIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Diferencias Por Ubicación'} />
                    </ListItem>
                </Link>*/}
                <Link to="/high_dollar" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <AttachMoneyIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'High Dollar'} />
                    </ListItem>
                </Link>
                <Link to="/observaciones" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <PageviewIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Observaciones'} />
                    </ListItem>
                </Link>
                <Link to="/rendimiento" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <StarsIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Rendimiento'} />
                    </ListItem>
                </Link>
                <Link to="/historial" className={classes.link}>
                    <ListItem button onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
                        <ListItemIcon>
                            <HistoryIcon/>
                        </ListItemIcon>
                        <ListItemText primary={'Historial'} />
                    </ListItem>
                </Link>
            </List>
        </div>
    );

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <Grid spacing={1} container direction={"row"} alignItems={"center"} justifyContent={"flex-start"}>
                        <Grid item>
                            <IconButton edge="start" className={classes.menuButton} onClick={toggleDrawer('left', true)} color="inherit" aria-label="menu">
                                <MenuIcon/> Menú
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <Typography variant="h6" className={classes.title}>
                                NEPTUNO {version}
                            </Typography>
                        </Grid>
                        { datos &&
                            <Grid item>
                                -
                            </Grid>}
                        { datos &&
                            <Grid item>
                                <Typography variant="h6" className={classes.title}>
                                 {datos.folio}
                                </Typography>
                            </Grid>}
                        { datos &&
                            <Grid item>
                                <Typography variant="h6" className={classes.title}>
                                    {datos.fecha.split("-").reverse().join("/")}
                                </Typography>
                            </Grid>}
                        { datos &&
                            <Grid item>
                                <Typography variant="h6" className={classes.title}>
                                    {datos.cliente}
                                </Typography>
                            </Grid>}
                        { datos &&
                            <Grid item>
                                <Typography variant="h6" className={classes.title}>
                                    {datos.centro_descripcion}
                                </Typography>
                            </Grid>}
                    </Grid>
                    <Grid container direction={"row"} alignItems={"center"} justifyContent={"flex-end"}>
                        {name_host !== 'scaneptuno.cl' && 
                            <Grid item>
                                <IndicadorConexion/>
                            </Grid>}
                        <Grid item>
                            <Typography variant="subtitle1" className={classes.title}>
                                {user.nombre}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                classes={{
                                    paper: classes.paper
                                }}
                                id="menu-appbar"
                                getContentAnchorEl={null}
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                keepMounted
                                elevation={0}
                                open={open}
                                onClose={handleClose}
                            >
                                <MenuItem disabled={!existeFolio} onClick={handlePass}>Contraseña supervisión</MenuItem>
                                <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
                            </Menu>
                        </Grid>
                        <Grid>
                            <Tooltip title={"Ver procesos"}>
                                <span>
                                    <IconButton
                                        disabled={!existeFolio && (name_host !== 'scaneptuno.cl')}
                                        size={"medium"}
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleChangeProcesos}
                                        color="inherit"
                                    >
                                        <SvgIcon>
                                            <path fill="currentColor" d="M9,7V17H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2Z" />
                                        </SvgIcon>
                                    </IconButton>
                                </span>
                            </Tooltip>

                            <Dialog fullWidth maxWidth={"lg"} onClose={handleCloseProcesos} aria-labelledby="simple-dialog-title" open={openProcesos}
                                aria-describedby="simple-dialog-content" 
                                disableRestoreFocus
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 0 }}>
                                <DialogTitle id="simple-dialog-title" >Procesos</DialogTitle>
                                <DialogContent id="simple-dialog-content">
                                    <TablaProcesos/>
                                </DialogContent>
                            </Dialog>

                            <Dialog open={openPass} onClose={handleClosePass}  disableRestoreFocus
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 0 }}>
                                <DialogTitle id="simple-dialog-title" >Contraseña supervisión</DialogTitle>
                                <DialogContent id="simple-dialog-content">
                                    <DialogPassSupervision/>
                                </DialogContent>
                            </Dialog>

                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <React.Fragment key={'left'}>
                {
                    menu === 'panelSodimac' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuPanelSodimac('left')}
                    </SwipeableDrawer>
                }
                 {
                    menu === 'panelAuditorias' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuPanelAuditorias('left')}
                    </SwipeableDrawer>
                }
                {
                    menu === 'validadorWalmart' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuValidadorWalmart('left')}
                    </SwipeableDrawer>
                }
                {
                    menu === 'analistaWalmart' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuAnalistaWalmart('left')}
                    </SwipeableDrawer>
                }
                { menu === 'oficina' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuOficina('left')}
                    </SwipeableDrawer>
                }
                { menu === 'admin' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuAdmin('left')}
                    </SwipeableDrawer>
                }
                { menu === 'general' &&
                    <SwipeableDrawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        onOpen={toggleDrawer('left', true)}>
                        {menuGeneral('left')}
                    </SwipeableDrawer>
                }

            </React.Fragment>
        </div>
    );
}